import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const {
  CustomerTransition: { getCustomerTransition },
} = apiUrls;

export const CUSTOMER_TRANSITION_SUCCESS = 'CUSTOMER_TRANSITION_SUCCESS';
export const CUSTOMER_TRANSITION_LOADING = 'CUSTOMER_TRANSITION_LOADING';

export const getCustomerTransitionData = ({ fromDate, toDate }) => async (dispatch) => {
    try {
      const { url } = getCustomerTransition;
      const requestData = {
        ...getCustomerTransition,
        url: url.replace('{{fromdate}}', fromDate).replace('{{todate}}', toDate),
      };
      const data = await REQUEST(requestData);
      dispatch({
        type: CUSTOMER_TRANSITION_SUCCESS,
        data,
      });
    } catch (e) {
      dispatch({
        type: CUSTOMER_TRANSITION_SUCCESS,
        data: {
          code: '',
          modal: null,
          notifications: null,
          paginationInfo: null,
        },
      });
    }
  };

export const handleLoader = isLoading => (dispatch) => {
  dispatch({
    type: CUSTOMER_TRANSITION_LOADING,
    isLoading,
  });
};
